import {SyncEventType} from '../../enums/syncEventType';
import {RealtimeEvent} from './realtimeEvent';

export class EventIssuecardToForeground implements RealtimeEvent {

  public readonly type = SyncEventType.ISSUECARD_TO_FOREGROUND;
  public issueId: number;
  public avatar: string;

  constructor(issueId: number, avatar: string) {
    this.issueId = issueId;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssuecardToForeground {
    return new EventIssuecardToForeground(
      payload['issueId'], payload['avatar']
    );
  }

}

